module.exports = __webpack_public_path__ + "static/media/hammersmith_sketch.e55a3764.png";